import { render } from "./sForm.vue?vue&type=template&id=4c0698e1&scoped=true"
import script from "./sForm.vue?vue&type=script&lang=js"
export * from "./sForm.vue?vue&type=script&lang=js"

import "./sForm.vue?vue&type=style&index=0&id=4c0698e1&scoped=true&lang=less"
import "./sForm.vue?vue&type=style&index=1&id=4c0698e1&lang=less"
/* custom blocks */
import block0 from "./sForm.vue?vue&type=custom&index=0&blockType=docs&lang=md"
if (typeof block0 === 'function') block0(script)


import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0698e1"]])

export default __exports__